import React from 'react';

export function Massage() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">QUIROMASAJE</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Masaje 30 minutos</h2>
            <p className="text-gray-600">
              Sesión de masaje ideal para tratar una zona específica o para una primera toma de contacto con el quiromasaje.
              <br /><br />
              <strong>Duración:</strong> 30 minutos
              <br />
              <strong>Precio:</strong> 30€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Masaje 45 minutos</h2>
            <p className="text-gray-600">
              Tiempo suficiente para un masaje descontracturante de espalda y cuello o uno circulatorio de piernas y abdomen.
              <br /><br />
              <strong>Duración:</strong> 45 minutos
              <br />
              <strong>Precio:</strong> 38€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Masaje 60 minutos</h2>
            <p className="text-gray-600">
              Sesión perfecta para un masaje relajante de piernas, espalda y cuello.
              <br /><br />
              <strong>Duración:</strong> 60 minutos
              <br />
              <strong>Precio:</strong> 48€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Masaje 90 minutos</h2>
            <p className="text-gray-600">
              Experiencia completa que combina un masaje relajante con envoltura de espalda para una relajación profunda.
              <br /><br />
              <strong>Duración:</strong> 90 minutos
              <br />
              <strong>Precio:</strong> 75€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Bono 4 + 1</h2>
            <p className="text-gray-600">
              Reserva 4 sesiones y obtén una adicional totalmente gratis. Válido para cualquier duración de masaje.
             <br /><br />
             <strong>Caducidad:</strong> 6 meses.
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}